/**
 * @file 跨数据类型通用的数据处理相关的 hooks
 */
import { useRef, useMemo } from 'react';
import { isEqual } from '../functions/lodash';
/**
 * 拷贝一个值，常用于拷贝引用类型，只在 _.isEqual(old, new) 为 false 时才更新拷贝.
 * 将拷贝后的值作为一些 hook 的依赖项，可以避免因对象引用改变导致重复执行逻辑的问题.
 * 比如对性能敏感的组件可在内部用该 hook 来稳定一个外部传入的, 引用可能很不稳定的变量.
 *
 * @category Data Hook
 * @param value - 原始变量
 * @returns 引用更稳定的变量, 只在 _.isEqual(old, new) 为 false 时才更新
 */
export const useLazyCopy = (value) => {
    const ref = useRef(value);
    return useMemo(() => {
        if (!isEqual(ref.current, value)) {
            ref.current = value;
        }
        return ref.current;
    }, [value]);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9kYXRhLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBRUgsT0FBTyxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsTUFBTSxPQUFPLENBQUE7QUFFdkMsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLHFCQUFxQixDQUFBO0FBRTdDOzs7Ozs7OztHQVFHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUFHLENBQUksS0FBUSxFQUFFLEVBQUU7SUFDekMsTUFBTSxHQUFHLEdBQUcsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFBO0lBRXpCLE9BQU8sT0FBTyxDQUFDLEdBQUcsRUFBRTtRQUNsQixJQUFJLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxPQUFPLEVBQUUsS0FBSyxDQUFDLEVBQUU7WUFDaEMsR0FBRyxDQUFDLE9BQU8sR0FBRyxLQUFLLENBQUE7U0FDcEI7UUFFRCxPQUFPLEdBQUcsQ0FBQyxPQUFPLENBQUE7SUFDcEIsQ0FBQyxFQUFFLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQTtBQUNiLENBQUMsQ0FBQSJ9